/**
 * Footer of the website
 *
 * @remarks
 * Included only in the landing page at the moment.
 * Unclear where else to add.
 */

import {
  Box,
  Flex,
  HStack,
  Link as ChakraLink,
  List,
  ListItem,
  Text,
  useMediaQuery,
  VStack,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { MailIcon } from "../atoms/HJSIcons";
import _ from "lodash";
import useAuth from "hooks/useAuth";

interface IFooterLink {
  to: string;
  label: string;
}

const FooterLinks: readonly IFooterLink[] = [
  { to: "/about", label: "About" },
  { to: "/#surveys", label: "Surveys" },
  { to: "/jobs/search", label: "Job Search" },
  { to: "/jobs/saved", label: "Saved Jobs" },
  { to: "/jobs/applied", label: "Applied Jobs" },
];

const Footer: () => JSX.Element = () => {
  const [isColumn] = useMediaQuery("(max-width:600px)");

  const { isUnlockedServices } = useAuth();
  return (
    <Box
      w="100vw"
      // mt="2rem !important"
      boxShadow="0px 18px 36px rgb(0 0 0 / 25%)"
    >
      <Flex
        flexDirection={`${isColumn ? `column` : `row`}`}
        w="full"
        py={{ base: 8, md: 20 }}
        px={[4, 4, 20, 32]}
        alignItems="flex-start"
        justifyContent="space-between"
        gap={[7, 8, 9]}
        maxWidth={{ "3xl": "80%" }}
        margin={{ "3xl": "auto" }}
      >
        <Text color="hjsFooterBlack" fontWeight="600">
          &copy; Good Business Lab {new Date().getFullYear()}
        </Text>
        <List>
          {FooterLinks.map((FooterLink, idx: number) => (
            <ListItem key={_.uniqueId("footer_")}>
              <ChakraLink
                color="hjsFooterBlack"
                fontWeight="600"
                className={`${
                  idx > 0 && !isUnlockedServices ? "disable-link" : ""
                }`}
                to={FooterLink.to}
                as={Link}
              >
                {FooterLink.label}
              </ChakraLink>
            </ListItem>
          ))}
        </List>
        <VStack alignItems="flex-start">
          <HStack>
            <MailIcon fill="none" />
            <Text color="hjsFooterBlack" fontWeight="600">
              Contact us
            </Text>
          </HStack>
          <ChakraLink
            color="teal.600"
            href="mailto:support@helpingjobseekers.org"
            fontSize="0.8rem"
          >
            support@helpingjobseekers.org
          </ChakraLink>
        </VStack>
      </Flex>
    </Box>
  );
};

export default Footer;
